// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center[data-v-7ad8dcd2] {\n  padding: 0.2rem;\n  background-color: #f1f1f1;\n}\n.center p[data-v-7ad8dcd2] {\n    margin-right: 0.1rem;\n}\n", ""]);
// Exports
module.exports = exports;
